import { c as _c } from "react/compiler-runtime";
import { IcoCirclePlay16, IcoRobot16 } from '@onefootprint/icons';
import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Button, DropdownButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import usePlaybookAudit from '../../../../hooks/use-playbook-audit';
type TestModeButtonProps = {
  label: string;
  onClick: () => void;
  selectedVersion: Pick<PlaybookVersionNoGraph, 'id' | 'version'>;
};
type TestModeButtonViewProps = Omit<TestModeButtonProps, 'selectedVersion'> & {
  onAudit?: () => void;
  isAuditing?: boolean;
};
const TestModeButtonView = t0 => {
  const $ = _c(26);
  const {
    label,
    onClick,
    onAudit,
    isAuditing
  } = t0;
  const isMobile = useMobileLayout();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "testMode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  if (onAudit) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== onClick || $[4] !== t2) {
      t3 = {
        value: "test",
        label: t2,
        iconLeft: IcoCirclePlay16,
        onSelect: onClick
      };
      $[3] = onClick;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t) {
      t4 = t(_temp2);
      $[6] = t;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== onAudit || $[9] !== t4) {
      t5 = {
        value: "audit",
        label: t4,
        iconLeft: IcoRobot16,
        onSelect: onAudit
      };
      $[8] = onAudit;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
      t6 = [t3, t5];
      $[11] = t3;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== isAuditing || $[15] !== label || $[16] !== t6) {
      t7 = <DropdownButton size="compact" variant="secondary" loading={isAuditing} disabled={isAuditing} options={t6}>{label}</DropdownButton>;
      $[14] = isAuditing;
      $[15] = label;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  const t2 = isMobile ? undefined : IcoCirclePlay16;
  let t3;
  if ($[18] !== isMobile || $[19] !== label) {
    t3 = isMobile ? <IcoCirclePlay16 /> : label;
    $[18] = isMobile;
    $[19] = label;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== label || $[22] !== onClick || $[23] !== t2 || $[24] !== t3) {
    t4 = <Button aria-label={label} onClick={onClick} size="compact" variant="secondary" prefixIcon={t2}>{t3}</Button>;
    $[21] = label;
    $[22] = onClick;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
};
const TestModeButton = t0 => {
  const $ = _c(7);
  let props;
  let selectedVersion;
  if ($[0] !== t0) {
    ({
      selectedVersion,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = selectedVersion;
  } else {
    props = $[1];
    selectedVersion = $[2];
  }
  const {
    audit,
    canAudit,
    isAuditing
  } = usePlaybookAudit(selectedVersion);
  const t1 = canAudit ? audit : undefined;
  let t2;
  if ($[3] !== isAuditing || $[4] !== props || $[5] !== t1) {
    t2 = <TestModeButtonView {...props} onAudit={t1} isAuditing={isAuditing} />;
    $[3] = isAuditing;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export { TestModeButton, TestModeButtonView };
function _temp($) {
  return $.runTest;
}
function _temp2($_0) {
  return $_0.validateWithPercy;
}